import { SmartBriefAudienceSelection, SmartBriefConversation } from './molecules/conversation/smart-brief-conversation';

export type SmartBriefDraftWrite = {
  businessAccountId: string;
  conversation: SmartBriefConversation;
  composerText: string;
  campaignId: string | null;
  pricingModelId: string | null;
};

/** The body saved once a brief type is chosen. Intro stays unsaved. */
export function smartBriefDraftWrite(input: {
  businessAccountId: string;
  conversation: SmartBriefConversation;
  composerText: string;
  campaignId: string | null;
  pricingModelId: string | null;
  audienceSelection: SmartBriefAudienceSelection | null;
}): SmartBriefDraftWrite | null {
  if (!input.conversation.draft.briefType) {
    return null;
  }
  const ugc = input.conversation.draft.briefType === 'ugc';
  return {
    businessAccountId: input.businessAccountId,
    conversation: {
      ...input.conversation,
      draft: { ...input.conversation.draft, audienceSelection: input.audienceSelection },
    },
    composerText: input.composerText,
    campaignId: ugc ? blankToNull(input.campaignId) : null,
    pricingModelId: ugc ? blankToNull(input.pricingModelId) : null,
  };
}

function blankToNull(value: string | null): string | null {
  const trimmed = value?.trim() ?? '';
  return trimmed.length > 0 ? trimmed : null;
}
